import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import LandingPage from './components/LandingPage.jsx';
import LoginPage from './components/LoginPage.jsx';
import UploadPage from './components/UploadPage.jsx';
import SharePage from './components/SharePage.jsx';
import PricingPage from './components/PricingPage.jsx';
import PaymentSuccess from './components/PaymentSuccess.jsx';
import EmailVerificationPage from './components/EmailVerificationPage.jsx';
import './index.css';

// Page transition wrapper
const PageWrapper = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};

// Animated Routes Component
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route 
          path="/" 
          element={
            <PageWrapper>
              <LandingPage />
            </PageWrapper>
          } 
        />
        <Route 
          path="/login" 
          element={
            <PageWrapper>
              <LoginPage />
            </PageWrapper>
          } 
        />
        <Route 
          path="/upload" 
          element={
            <PageWrapper>
              <UploadPage />
            </PageWrapper>
          } 
        />
        <Route 
          path="/share/:token" 
          element={
            <PageWrapper>
              <SharePage />
            </PageWrapper>
          } 
        />
        <Route 
          path="/pricing" 
          element={
            <PageWrapper>
              <PricingPage />
            </PageWrapper>
          } 
        />
        <Route 
          path="/payment-success" 
          element={
            <PageWrapper>
              <PaymentSuccess />
            </PageWrapper>
          } 
        />
        <Route 
          path="/verify-email/:token" 
          element={
            <PageWrapper>
              <EmailVerificationPage />
            </PageWrapper>
          } 
        />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-zinc-950 text-zinc-100">
        <AnimatedRoutes />
      </div>
    </Router>
  );
}

export default App;
